import React from "react";

const Nav = (props) => {
    return (
        <div className="nav">
            
            <h1>Choose a Sort Algorithm</h1>
        </div>
    )
}

export default Nav;